 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"KeyLogin":"KeyLogin","LiveRoom":"LiveRoom","PageError":"PageError","RecordVideo":"RecordVideo","SplitScreen":"SplitScreen","VideoPolling":"VideoPolling","ChatAuth":"ChatAuth","notfound":"notfound","qa":"qa","yun":"yun"}[chunkId]||chunkId) + "." + "cb1ffa4c" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"KeyLogin":1,"LiveRoom":1,"PageError":1,"RecordVideo":1,"SplitScreen":1,"VideoPolling":1,"chunk-0137fe65":1,"chunk-38a0362e":1,"chunk-e1caf93e":1,"chunk-06388169":1,"chunk-07f60e9e":1,"chunk-0801e9a9":1,"chunk-08c2593e":1,"chunk-3c1820d0":1,"chunk-1330167e":1,"chunk-241e49be":1,"chunk-281bba23":1,"chunk-35e650f5":1,"chunk-4d2dbbd2":1,"chunk-4da5306c":1,"chunk-52dcf3fe":1,"chunk-5446905a":1,"chunk-55b74cdf":1,"chunk-5640b73c":1,"chunk-31c214d8":1,"chunk-5d5b948c":1,"chunk-64da0fbe":1,"chunk-730cd554":1,"chunk-83e00d14":1,"chunk-867ded3c":1,"chunk-956385e8":1,"chunk-a9f901f0":1,"chunk-b0d3d4a4":1,"chunk-b2a3640a":1,"chunk-f63771a4":1,"notfound":1,"qa":1,"yun":1,"chunk-8845639e":1,"chunk-67e36784":1,"chunk-627844bc":1,"chunk-944cdf54":1,"chunk-3e6ff83e":1,"chunk-6ffc1cea":1,"chunk-3b2b4e5c":1,"chunk-65115d18":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"KeyLogin":"KeyLogin","LiveRoom":"LiveRoom","PageError":"PageError","RecordVideo":"RecordVideo","SplitScreen":"SplitScreen","VideoPolling":"VideoPolling","ChatAuth":"ChatAuth","notfound":"notfound","qa":"qa","yun":"yun"}[chunkId]||chunkId) + "." + {"KeyLogin":"fb58b616","LiveRoom":"e14bfd6a","PageError":"bd3807db","RecordVideo":"e14bfd6a","SplitScreen":"78eea796","VideoPolling":"720e1602","chunk-0137fe65":"e15b53df","chunk-38a0362e":"e057ff87","chunk-e1caf93e":"c73bb54d","chunk-06388169":"bb336b80","chunk-07f60e9e":"8d51a368","chunk-0801e9a9":"bd5acbcf","chunk-08c2593e":"95280335","chunk-3c1820d0":"352cc460","chunk-1330167e":"5c8d0746","chunk-241e49be":"676922a9","chunk-281bba23":"fa302bbd","chunk-2d0a3ccb":"31d6cfe0","chunk-2d0a3ce8":"31d6cfe0","chunk-2d0af7f1":"31d6cfe0","chunk-2d0b9bc1":"31d6cfe0","chunk-2d0b9dd7":"31d6cfe0","chunk-2d0bd9a2":"31d6cfe0","chunk-2d0c1003":"31d6cfe0","chunk-2d0c18d8":"31d6cfe0","chunk-2d0c73ac":"31d6cfe0","chunk-2d0cb780":"31d6cfe0","chunk-2d0cef05":"31d6cfe0","chunk-2d2299d4":"31d6cfe0","chunk-2d237d14":"31d6cfe0","chunk-2d0e4577":"31d6cfe0","chunk-2d0e5edb":"31d6cfe0","chunk-2d0e6c0d":"31d6cfe0","chunk-2d0f0692":"31d6cfe0","chunk-2d20732e":"31d6cfe0","chunk-2d2089e1":"31d6cfe0","chunk-2d20f022":"31d6cfe0","chunk-2d210289":"31d6cfe0","chunk-2d2134f9":"31d6cfe0","chunk-2d229ba8":"31d6cfe0","chunk-35e650f5":"373e4beb","chunk-4d2dbbd2":"626ca8b3","chunk-4da5306c":"eb832164","chunk-52dcf3fe":"7b8614b8","chunk-5446905a":"58ca7761","ChatAuth":"31d6cfe0","chunk-55b74cdf":"1640d760","chunk-5640b73c":"84fe356b","chunk-31c214d8":"67409767","chunk-5d5b948c":"03fe171b","chunk-64da0fbe":"dfae38c2","chunk-730cd554":"a3b863e1","chunk-83e00d14":"6a7f3b5a","chunk-867ded3c":"6ccd9382","chunk-956385e8":"8f1022f7","chunk-a9f901f0":"34eb61b2","chunk-b0d3d4a4":"c8a34c59","chunk-b2a3640a":"223732ba","chunk-bac6c678":"31d6cfe0","chunk-f63771a4":"b1e76c60","notfound":"bb0e5b11","qa":"2177a6c2","yun":"c8b64d92","chunk-8845639e":"0490f5ef","chunk-67e36784":"5eb20928","chunk-627844bc":"7f6df8e6","chunk-944cdf54":"83b3dad2","chunk-3e6ff83e":"9c8eb60f","chunk-6ffc1cea":"4b70e4f1","chunk-3b2b4e5c":"8b415a29","chunk-65115d18":"b98bd02c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//cnstatic01.e.vhall.com/common-static/@projectName/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
